module.exports = __webpack_public_path__ + "media/images/riders/small/REECE_WILSON-73ce8c7fb807a757724caed8ef8c480e.png";